import React from 'react';
import Sidebar from '../components/Sidebar';
import DashboardNavbar from '../components/DashboardNavbar';
import UsersTable from '../components/UsersTable';

const Users = () => {
    return (
        <div className="d-flex entire-bg-color">
            <Sidebar />
            <div className="flex-grow-1">
                <DashboardNavbar />

                <div style={{marginTop: '70px'}}></div>
                
                <UsersTable/>


            </div>
        </div>
    );
};

export default Users;